import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-paper" data-testid="forgot-password">
      <div className="w-full max-w-md">
        <div className="eyebrow mb-3">Password reset</div>
        <h1 className="font-heading font-light text-4xl tracking-tighter">Reset your password.</h1>
        {sent ? (
          <div className="mt-10 border border-line p-6" data-testid="forgot-sent">
            <p className="text-sm">
              If an account exists for <strong>{email}</strong>, a reset link has been generated. In production it would be emailed. For this build, ask your Super Admin to check the server logs for the reset token.
            </p>
            <div className="mt-6 flex items-center gap-4 text-xs">
              <Link to="/staff/login" className="border-b border-ink pb-0.5">Back to sign in</Link>
              <Link to="/staff/reset-password" className="border-b border-ink pb-0.5">I have a token</Link>
            </div>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-8 space-y-6">
            <div>
              <label className="eyebrow block mb-1">Email</label>
              <input required type="email" data-testid="forgot-email" className="line-input" value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button type="submit" disabled={loading} data-testid="forgot-submit" className="w-full bg-ink text-white py-4 text-sm hover:bg-ink/90 disabled:opacity-60">
              {loading ? "Sending…" : "Send reset link"}
            </button>
            <div className="flex justify-between text-xs">
              <Link to="/staff/login" className="text-stone hover:text-ink">Back to sign in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
